import {
  faCheck,
  faCheckCircle,
  faClose,
} from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage } from 'react-intl';

import Button, { Color } from 'atoms/buttons/Button';
import IconButton from 'atoms/buttons/IconButton';
import { FontAwesomeIcon } from 'atoms/icons';
import { Horizontal } from 'atoms/layout/flex';
import { useIntlContext } from 'contexts/intl';
import { fantasy } from 'lib/glossary';

export type ActionType = 'accept' | 'reject' | 'challenge';

export type StatusType =
  | 'accepted'
  | 'refused'
  | 'created_by_me'
  | 'created_by_opponent'
  | 'challengeable'
  | 'expired';

type Props = {
  status: StatusType;
  disabled?: boolean;
  onClick?: (action: ActionType) => void;
  hideAccept?: boolean;
  buttonColors?: {
    [key in StatusType]?: Color;
  };
};
export const Cta = ({
  status,
  disabled,
  onClick,
  hideAccept,
  buttonColors,
}: Props) => {
  const { formatMessage } = useIntlContext();
  switch (status) {
    case 'accepted':
      return (
        <Button
          size="small"
          color={buttonColors?.accepted || 'tertiary'}
          disabled
        >
          <FormattedMessage
            id="rivals.Friend.Status.accepted"
            defaultMessage="Accepted"
          />
        </Button>
      );
    case 'refused':
      return (
        <Button
          size="small"
          color={buttonColors?.refused || 'tertiary'}
          disabled
        >
          <FormattedMessage
            id="rivals.Friend.Status.refused"
            defaultMessage="Refused"
          />
        </Button>
      );
    case 'expired':
      return (
        <Button
          size="small"
          color={buttonColors?.expired || 'tertiary'}
          disabled
        >
          <FormattedMessage
            id="rivals.Friend.Status.expired"
            defaultMessage="Expired"
          />
        </Button>
      );
    case 'created_by_me':
      return (
        <Button
          size="small"
          color={buttonColors?.created_by_me || 'tertiary'}
          disabled
        >
          <Horizontal>
            <FontAwesomeIcon icon={faCheckCircle} color="var(--c-green-600)" />
            <FormattedMessage
              id="rivals.Friend.Status.invitationSent"
              defaultMessage="Requested"
            />
          </Horizontal>
        </Button>
      );
    case 'created_by_opponent':
      if (hideAccept) {
        return null;
      }

      return (
        <Horizontal>
          <IconButton
            color={buttonColors?.created_by_opponent || 'red'}
            disabled={disabled}
            onClick={() => onClick?.('reject')}
            icon={faClose}
            aria-label={formatMessage({
              id: 'rivals.Friend.Status.reject',
              defaultMessage: 'Reject',
            })}
          />
          <IconButton
            color={buttonColors?.created_by_opponent || 'secondary'}
            disabled={disabled}
            onClick={() => onClick?.('accept')}
            icon={faCheck}
            aria-label={formatMessage({
              id: 'rivals.Friend.Status.ept',
              defaultMessage: 'Accept',
            })}
          />
        </Horizontal>
      );
    default:
      return (
        <Button
          size="small"
          color={buttonColors?.challengeable || 'tertiary'}
          disabled={disabled}
          onClick={() => onClick?.('challenge')}
        >
          <FormattedMessage {...fantasy.challenge} />
        </Button>
      );
  }
};
